import SessionPhoto from "../Assets/Photos/Carly-Instructing.jpeg";
import Seo from "../Components/Seo";

const faqs = [
  {
    question: "What does hypnotherapy feel like?",
    answer:
      "Hypnotherapy is a deeply relaxing and calming experience. Most people describe it as similar to daydreaming or being absorbed in a book - you are aware of what is happening, but feel calm yet focused."
  },
  {
    question: "Will I lose control?",
    answer:
      "No - you are always in control. Hypnosis is a natural state of focused attention, and you can come out of it at any time. You will not do or say anything that does not feel right to you."
  },
  {
    question: "How many sessions will I need?",
    answer:
      "This varies depending on what you would like support with, but many people begin to notice positive changes within a few sessions. We will discuss a plan that feels right for you, however we suggest between 6-12 sessions."
  },
  {
    question: "Can hypnotherapy really help with anxiety and burnout?",
    answer:
      "Yes - hypnotherapy works by helping to regulate your nervous system and shift unhelpful patterns at a deeper level, making it particularly effective for stress, anxiety, and burnout."
  },
  {
    question: "Do I need to prepare anything?",
    answer:
      "No preparation is needed. Just come as you are - this is a space for you to feel supported, understood, and at ease."
  }
];

export default function FAQ() {
  return (
    <div className="mx-auto max-w-6xl space-y-6 pb-10">
      <Seo
        title="FAQs"
        description="Answers to common questions about hypnotherapy sessions, what it feels like, and how Calm Coast Hypnotherapy can help."
        path="/faqs"
      />
      <section className="grid gap-6 rounded-3xl bg-white p-6 shadow-sm ring-1 ring-coastal-100 md:grid-cols-5">
        <div className="md:col-span-3">
          <p className="text-sm font-semibold uppercase tracking-wide text-coastal-600">Frequently Asked Questions</p>
          <h1 className="mt-2 font-roboto text-4xl font-semibold text-coastal-800">FAQs</h1>
          <p className="mt-3 text-slate-700">
            Answers to common questions about what to expect from solution focused hypnotherapy sessions.
          </p>
        </div>
        <div className="md:col-span-2">
          <img src={SessionPhoto} alt="Hypnotherapy session space" className="h-full min-h-[240px] w-full rounded-2xl object-cover" />
        </div>
      </section>

      <section className="space-y-3">
        {faqs.map((item) => (
          <article key={item.question} className="rounded-2xl bg-coastal-50 p-5 ring-1 ring-coastal-100">
            <h2 className="font-roboto text-xl font-semibold text-coastal-800">{item.question}</h2>
            <p className="mt-2 leading-relaxed text-slate-700">{item.answer}</p>
          </article>
        ))}
      </section>
    </div>
  );
}
